export default "__VITE_ASSET__B43ENyxZ__"